import React, { useState } from "react";
import "../FAQ.css";
import { motion } from "framer-motion";
import { FaPlus, FaMinus, FaShieldAlt } from "react-icons/fa";


const faqData = [

    {
        question: "What cybersecurity services does BlueLotus Infrasafety Projects Private Limited provide?",
        answer:
            "BlueLotus Infrasafety Projects Private Limited provides complete cybersecurity solutions including threat monitoring, vulnerability assessment, penetration testing, cloud security, compliance management, incident response, and managed security services."
    },


    {
        question: "Why does my business need cybersecurity protection?",
        answer:
            "Modern businesses face increasing cyber threats such as ransomware, phishing, data breaches, and identity attacks. Cybersecurity helps protect your sensitive data, applications, infrastructure, and customer trust."
    },


    {
        question: "Does BlueLotus provide 24×7 security monitoring?",
        answer:
            "Yes. Our security experts continuously monitor your systems, detect suspicious activities, analyze threats, and respond quickly to prevent security incidents."
    },


    {
        question: "What is Zero Trust Security and why is it important?",
        answer:
            "Zero Trust Security follows the principle of never trusting automatically. Every user, device, and application must be verified before accessing business resources, reducing unauthorized access risks."
    },


    {
        question: "Can BlueLotus Infrasafety Projects Private Limited help with compliance requirements?",
        answer:
            "Yes. We help organizations achieve security compliance by performing assessments, identifying risks, implementing controls, and preparing security documentation."
    },


    {
        question: "How quickly can BlueLotus Infrasafety Projects Private Limited respond to a cyber incident?",
        answer:
            "Our incident response team works rapidly to identify threats, contain attacks, minimize damage, and restore business operations with minimal downtime."
    },


    {
        question: "Does BlueLotus Infrasafety Projects Private Limited protect cloud environments?",
        answer:
            "Yes. We secure cloud infrastructure, applications, workloads, and data using modern cloud security practices and continuous monitoring."
    },


];


const FAQ = () => {


    const [active, setActive] = useState(null);


    return (

        <section className="faq-section">


            <div className="container">


                <motion.div
                    className="faq-heading"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: .7 }}
                >


                    <span className="faq-tag">

                        <FaShieldAlt />

                        Cybersecurity FAQ

                    </span>


                    <h2>

                        Frequently Asked
                        <span> Security Questions</span>

                    </h2>


                    <p>

                        Find answers to common cybersecurity questions
                        about our services, protection strategies,
                        and security solutions.

                    </p>


                </motion.div>



                <div className="faq-wrapper">


                    {
                        faqData.map((item, index) => (


                            <motion.div

                                className={`faq-item ${active === index ? "active" : ""
                                    }`}

                                key={index}

                                initial={{ opacity: 0, y: 30 }}

                                whileInView={{ opacity: 1, y: 0 }}

                                viewport={{ once: true }}

                                transition={{
                                    duration: .5,
                                    delay: index * .1
                                }}

                            >


                                <div

                                    className="faq-question"

                                    onClick={() => setActive(
                                        active === index ? null : index
                                    )}

                                >


                                    <h3>

                                        {item.question}

                                    </h3>


                                    <span>

                                        {
                                            active === index
                                                ?
                                                <FaMinus />
                                                :
                                                <FaPlus />
                                        }

                                    </span>


                                </div>



                                <div className="faq-answer">


                                    <p>

                                        {item.answer}

                                    </p>


                                </div>



                            </motion.div>


                        ))

                    }


                </div>


            </div>


        </section>

    )

}


export default FAQ;